import 'assets/css/footer.scss';

export default function Footer() {
  return (
    <div className="footer">
      <div className='ft-con'>
        <div className='ft-top-section'>
          <div className='ft-bottom-row' style={{flex : 1}}>
            <span style={{fontSize:'18px', fontWeight:'bold'}}>㈜천호엔케어</span>
            <span style={{marginLeft:"10px"}}>대표이사 : 손동일</span>
          </div>
         
        </div>
        <div className='ft-bottom-section' >
          <div className='ft-bottom-row sec' style={{flex : 1}}>
            <div>
              <div><span >부산 본사</span>&nbsp;&nbsp;사업자명: <strong>㈜천호엔케어</strong></div>
              <div>
                사업자등록번호 : 606-86-19446&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;통신판매업신고 : 제 2009-부산부산진-0877 호 
                <input name="wrkr_no" type="text" defaultValue="6068619446" hidden/>
              </div>
              <div style={{ paddingTop: '5px' }}>건강기능식품 판매업신고 : 제2004-0154548호</div>
              <div>주소 : 부산광역시 부산진구 중앙대로 770 (부전동) 고촌빌딩, 2층 (주)천호엔케어</div>
            </div>
          </div>

          <div className='ft-bottom-row sec' style={{flex : 1}}>
            <div>
              <div><span >서울 지점</span>&nbsp;&nbsp;사업자명: <strong>㈜천호엔케어 서울지점</strong></div>
              <div>
                사업자등록번호 :220-85-40258&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;통신판매업신고 : 제 2021-서울종로-0763호
              </div>
              <div style={{ paddingTop: '5px' }}>건강기능식품 판매업신고 : 제2018-0029482호</div>
              <div>주소 : 서울특별시 종로구 새문안로 5길 19 13층(당주동 5, 로얄빌딩)</div>
            </div>
          </div>
        </div>
        <div className='ft-bottom-section' style={{flexDirection:'column'}}>
          <div className='ft-bottom-row'>
            <div style={{width:'110px'}}>고객센터 1522-1005</div><div style={{width:'10px', textAlign:'center'}}>|</div><div style={{width:'145px'}}>개인정보관리책임자 : 황연하</div><div style={{width:'10px', textAlign:'center'}}>|</div><div style={{width:'140px'}}>호스팅사업자: ㈜천호엔케어</div>
          </div>
          <div className='ft-bottom-row first'>
            <div>Copyrightⓒ ChunhoNcare co., Ltd All rights Reserved.</div>
          </div>
        </div>
      </div>
    </div>
  );
}